/**
 * Core types for the role-perspective navigation system (feat1.0 IA handoff).
 *
 * A `Perspective` (Tutor / Admin / Betrieb) is a NAVIGATION lens and is
 * orthogonal to the auth `UserRole` (viewer/operator/admin). Perspectives only
 * group and order menu items; access is still governed by `UserRole` via each
 * page's `minRole` in the page catalog. Routes are unaffected — the config only
 * controls visibility & grouping of menu entries.
 */
import { UserRole } from '../services/types';

export type Perspective = 'tutor' | 'admin' | 'betrieb';

export const PERSPECTIVES: Perspective[] = ['tutor', 'admin', 'betrieb'];

export const PERSPECTIVE_LABELS: Record<Perspective, string> = {
  tutor: 'Tutor',
  admin: 'Admin',
  betrieb: 'Betrieb',
};

export type PageId = string;

/** Sentinel group id for the "Nicht zugeordnet" tray. */
export const TRAY_ID = '__tray';

export interface NavPage {
  id: PageId;
  hidden: boolean;
}

export interface NavGroup {
  id: string;
  name: string;
  pages: NavPage[];
}

export interface PerspectiveNav {
  groups: NavGroup[];
  /** Pages not assigned to any group for this perspective. */
  tray: NavPage[];
}

export type NavConfig = Record<Perspective, PerspectiveNav>;

export interface PageCatalogEntry {
  /** Sidebar label. */
  label: string;
  /** Existing router path (unchanged by this feature). */
  route: string;
  /** Minimum auth role required to see/use the page. */
  minRole: UserRole;
}
